import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';

import BrokenImage from "../assets/broken-image.png";

const styles = makeStyles(theme => ({
	center: {
		display: "block",
		marginRight: "auto",
		marginLeft: "auto"
	},

	responsive: {
		maxWidth: "100%",
		height: "auto"
	},

	brokenImage: {
		margin: "auto",
		marginTop: "35px",
		marginBottom: "35px",
		opacity: "0.4",
		width: 150
	}
}));

function Thumbnail(props) {
	let classes = styles(),
		className = props.center ? classes.center : null;

	const imageLoaded = (event) => {
		let img = event.target;
		if (props.fitToHeight && img.src !== BrokenImage) {
			let maxWidth,
				ratio,
				imgH = img.height,
				imgW = img.width,
				fitTo = props.fitToHeight;

			//if (imgH >= imgW) {
				ratio = fitTo / imgH;
				maxWidth = ratio * imgW;
			//}

			img.width = maxWidth;
		}
	};

	const handleError = (event) => {
		let img = event.target;
		img.src = BrokenImage;
		img.className += ` ${classes.brokenImage}`;
	};

	return (
		<img src={props.image} onLoad={imageLoaded} onError={handleError}
			className={`${classes.responsive} ${className}`} alt=""/>
	);
}

Thumbnail.propTypes = {
	image: PropTypes.string,
	center: PropTypes.bool,
	fitToHeight: PropTypes.number
};

export default Thumbnail;